export default __webpack_public_path__ + "static/media/menu-close-black.c85e4f59.svg";